<template><div><h1>VUX V2.9.2 released</h1>
<h2><a href="/en/components/confirm.html">Confirm</a></h2>
<ul><li>[feature] Support prop: showCancelButton showConfirmButton #2795</li>
</ul>
<h2><a href="/en/components/datetime-view.html">DatetimeView</a></h2>
<ul><li>[fix] fix render error for DOM not found #2797</li>
</ul>
<h2><a href="/en/components/range.html">Range</a></h2>
<ul><li>[feature] add on-touchstart and on-touchend events #2804</li>
</ul>
<h2><a href="/en/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] fix stuck swipe after setting min-moving-distance #2773</li>
<li>[fix] fix error for repeat setting data in loop #2803</li>
</ul>
<h2><a href="/en/components/x-button.html">XButton</a></h2>
<ul><li>[feature] support styles variable for button #2748</li>
</ul>
<h2><a href="/en/components/x-img.html">XImg</a></h2>
<ul><li>[enhance] Support prop:separator #2744</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[fix] fix corsor misplce when set mask #2810</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.9.2 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.9.2-152.vue?e686809a